module.exports = __webpack_public_path__ + "static/media/icon_4.e7452573.png";